import {css} from "@panda/css";

import {Drawer} from "@pg-design/drawer-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {IFormProps} from "@pg-mono/form";
import {form} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {MobileOptionsModal} from "../../atoms/MobileOptionsModal";
import {hitFiltersInteraction} from "../../real_estate/tracking/hit_filters_interaction";
import {convertSearchFormToFiltersTracking} from "../../real_estate/utils/convert_search_form_to_filters_tracking";
import {useAppSelector} from "../../store/hooks";
import {Currency} from "../../types/Currency";
import {ILatestQuery} from "../../utils/latest_query";
import {useCountSearchFilters} from "../hooks/use_count_search_filters";
import {usePriceRanges} from "../hooks/use_price_ranges";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {IUseFilter} from "../types/IUseFilter";
import {IUseMobileFilter} from "../types/IUseMobileFilter";
import {getSearchFiltersByOfferType} from "../utils/get_search_filters_by_offer_type";
import {MobileSearchFilters} from "./MobileSearchFilters";
import {SearchFiltersWithAccordion} from "./SearchFiltersWithAccordion";

interface IOwnProps {
    useFilterHook: IUseFilter;
    useMobileFilterHook: IUseMobileFilter;
    latestQuery: ILatestQuery;
    handleSubmit: () => void;
    isAbroad?: boolean;
}

// interface IReduxFormProps {
//     values: ISearchFormValues;
//     errors?: Record<keyof TFormValues, string[]>;
//     onSubmit?: (e?: React.FormEvent<HTMLElement>) => void;
//     onChange: (values: Partial<ISearchFormValues>) => void;
//     onAfterChange?: <K extends keyof ISearchFormValues>(fieldName: K, value: ISearchFormValues[K]) => void;
// }

interface IProps extends IOwnProps, IFormProps<ISearchFiltersFormValues> {}

/**
 * TODOS
 * resetfilters - In investment form
 * it was () => props.formActions.clear() not from hook
 * onMobileResetForm={resetFilters}
 * Test if that's ok, that both will now have full flow from regular offers
 */

/**
 * SearchFilters - Main point of this component is to have a one place for "offer list" filters.
 * By "offer list" I mean standard offer listing, which may be a regular listing, investment listing or map listing.
 * So, what we actually mean by that is listings based on search form in redux.
 * It should be a place to connect offer list logic with simple UI components.
 *
 * Why? - We were duplicating a lot of logic between listings what caused errors when someone was not careful.
 */
export function SearchFiltersC(props: IProps) {
    const {useFilterHook, useMobileFilterHook, latestQuery, isAbroad = false, ...legacyFormProps} = props;

    const {isMobile} = useUserDevice();

    const {isDrawerOpen, closeDrawer, resetFilters} = useFilterHook;
    const {isMobileFiltersActive, closeMobileFilterModal, prevFilterState} = useMobileFilterHook;
    const {maxPrice} = usePriceRanges();

    const formValues = useAppSelector((state) => state.search.formValues) as ISearchFormValues;
    const searchFiltersConfig = getSearchFiltersByOfferType(formValues.type?.[0]);
    const {countBySlots} = useCountSearchFilters(formValues, searchFiltersConfig);

    const updateLegacyForm = (values: Partial<ISearchFormValues>) => {
        legacyFormProps.onChange?.(values);
    };

    const handleDrawerClose = () => {
        if (latestQuery.price_1 !== formValues.price.upper) {
            updateLegacyForm({price: {lower: "", upper: props.latestQuery.price_1 || ""}});
        }
        closeDrawer();
    };

    const closeWithGtm = () => {
        hitFiltersInteraction("close", convertSearchFormToFiltersTracking(formValues));
        handleDrawerClose();
    };

    // save form values on modal open to reset those values when form is discarded (Esc, Close)
    const discardFiltersModal = () => {
        closeMobileFilterModal(true);

        if (prevFilterState.current != null) {
            updateLegacyForm(prevFilterState.current);
        }
    };

    return (
        <>
            <Drawer isOpen={isDrawerOpen} onDrawerClose={closeWithGtm} contentStyle={{backgroundColor: getThemeVariable("colors.background.100")}}>
                <Drawer.Header>Filtry</Drawer.Header>

                <Drawer.Content className={drawerContentStyle}>
                    <SearchFiltersWithAccordion
                        searchFiltersSlots={searchFiltersConfig.slots}
                        searchFiltersCountBySlots={countBySlots}
                        legacyFormProps={legacyFormProps}
                        onClose={handleDrawerClose}
                        onResetForm={resetFilters}
                        currency={isAbroad ? Currency.EURO : Currency.PLN}
                        isAbroad={isAbroad}
                        filtersConfig={{
                            budget: {
                                maxPrice
                            }
                        }}
                    />
                </Drawer.Content>
            </Drawer>
            {isMobile && (
                <MobileOptionsModal modalHeading="Filtry" isOpen={isMobileFiltersActive} onModalClose={discardFiltersModal} className={mobileFiltersModalStyle}>
                    <MobileSearchFilters
                        searchFiltersSlots={searchFiltersConfig.slots}
                        searchFiltersCountBySlots={countBySlots}
                        legacyFormProps={legacyFormProps}
                        onMobileCloseModal={closeMobileFilterModal}
                        onMobileResetForm={resetFilters}
                        isAbroad={isAbroad}
                        filtersConfig={{
                            budget: {
                                maxPrice
                            }
                        }}
                    />
                </MobileOptionsModal>
            )}
        </>
    );
}

export const SearchFilters = form<ISearchFiltersFormValues, IProps>(SearchFiltersC);
// interface IOwnProps<TSearchFiltersForm extends {}> {
//     searchFiltersConfig: ISearchFilters<TSearchFiltersForm>;
//     searchFiltersCountBySlots?: Record<string, number>;
//     onClose?: () => void;
//     onResetForm?: () => void;
//     footerClearButtonText?: string;
//     footerSubmitButtonText?: string;
//     isNotificationsSubscriptionModal?: boolean;
//     currency?: Currency;
// }

// interface IProps extends IOwnProps<ISearchFiltersFormValues>, IFormProps<ISearchFiltersFormValues> {}

// export const SearchFiltersWithAccordion = form<ISearchFiltersFormValues, IProps>(SearchFiltersWithAccordionC);

const drawerContentStyle = css({
    display: "flex",
    flexDirection: "column",
    padding: 0,
    overflow: "hidden",
    height: "100%"
});

const mobileFiltersModalStyle = css({
    display: "flex",
    flexDirection: "column"
});
import {css} from "@panda/css";

import {Drawer} from "@pg-design/drawer-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {IFormProps} from "@pg-mono/form";
import {form} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {MobileOptionsModal} from "../../atoms/MobileOptionsModal";
import {hitFiltersInteraction} from "../../real_estate/tracking/hit_filters_interaction";
import {convertSearchFormToFiltersTracking} from "../../real_estate/utils/convert_search_form_to_filters_tracking";
import {useAppSelector} from "../../store/hooks";
import {Currency} from "../../types/Currency";
import {ILatestQuery} from "../../utils/latest_query";
import {useCountSearchFilters} from "../hooks/use_count_search_filters";
import {usePriceRanges} from "../hooks/use_price_ranges";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {IUseFilter} from "../types/IUseFilter";
import {IUseMobileFilter} from "../types/IUseMobileFilter";
import {getSearchFiltersByOfferType} from "../utils/get_search_filters_by_offer_type";
import {MobileSearchFilters} from "./MobileSearchFilters";
import {SearchFiltersWithAccordion} from "./SearchFiltersWithAccordion";

interface IOwnProps {
    useFilterHook: IUseFilter;
    useMobileFilterHook: IUseMobileFilter;
    latestQuery: ILatestQuery;
    handleSubmit: () => void;
    isAbroad?: boolean;
}

// interface IReduxFormProps {
//     values: ISearchFormValues;
//     errors?: Record<keyof TFormValues, string[]>;
//     onSubmit?: (e?: React.FormEvent<HTMLElement>) => void;
//     onChange: (values: Partial<ISearchFormValues>) => void;
//     onAfterChange?: <K extends keyof ISearchFormValues>(fieldName: K, value: ISearchFormValues[K]) => void;
// }

interface IProps extends IOwnProps, IFormProps<ISearchFiltersFormValues> {}

/**
 * TODOS
 * resetfilters - In investment form
 * it was () => props.formActions.clear() not from hook
 * onMobileResetForm={resetFilters}
 * Test if that's ok, that both will now have full flow from regular offers
 */

/**
 * SearchFilters - Main point of this component is to have a one place for "offer list" filters.
 * By "offer list" I mean standard offer listing, which may be a regular listing, investment listing or map listing.
 * So, what we actually mean by that is listings based on search form in redux.
 * It should be a place to connect offer list logic with simple UI components.
 *
 * Why? - We were duplicating a lot of logic between listings what caused errors when someone was not careful.
 */
export function SearchFiltersC(props: IProps) {
    const {useFilterHook, useMobileFilterHook, latestQuery, isAbroad = false, ...legacyFormProps} = props;

    const {isMobile} = useUserDevice();

    const {isDrawerOpen, closeDrawer, resetFilters} = useFilterHook;
    const {isMobileFiltersActive, closeMobileFilterModal, prevFilterState} = useMobileFilterHook;
    const {maxPrice} = usePriceRanges();

    const formValues = useAppSelector((state) => state.search.formValues) as ISearchFormValues;
    const searchFiltersConfig = getSearchFiltersByOfferType(formValues.type?.[0]);
    const {countBySlots} = useCountSearchFilters(formValues, searchFiltersConfig);

    const updateLegacyForm = (values: Partial<ISearchFormValues>) => {
        legacyFormProps.onChange?.(values);
    };

    const handleDrawerClose = () => {
        if (latestQuery.price_1 !== formValues.price.upper) {
            updateLegacyForm({price: {lower: "", upper: props.latestQuery.price_1 || ""}});
        }
        closeDrawer();
    };

    const closeWithGtm = () => {
        hitFiltersInteraction("close", convertSearchFormToFiltersTracking(formValues));
        handleDrawerClose();
    };

    // save form values on modal open to reset those values when form is discarded (Esc, Close)
    const discardFiltersModal = () => {
        closeMobileFilterModal(true);

        if (prevFilterState.current != null) {
            updateLegacyForm(prevFilterState.current);
        }
    };

    return (
        <>
            <Drawer isOpen={isDrawerOpen} onDrawerClose={closeWithGtm} contentStyle={{backgroundColor: getThemeVariable("colors.background.100")}}>
                <Drawer.Header>Filtry</Drawer.Header>

                <Drawer.Content className={drawerContentStyle}>
                    <SearchFiltersWithAccordion
                        searchFiltersSlots={searchFiltersConfig.slots}
                        searchFiltersCountBySlots={countBySlots}
                        legacyFormProps={legacyFormProps}
                        onClose={handleDrawerClose}
                        onResetForm={resetFilters}
                        currency={isAbroad ? Currency.EURO : Currency.PLN}
                        isAbroad={isAbroad}
                        filtersConfig={{
                            budget: {
                                maxPrice
                            }
                        }}
                    />
                </Drawer.Content>
            </Drawer>
            {isMobile && (
                <MobileOptionsModal modalHeading="Filtry" isOpen={isMobileFiltersActive} onModalClose={discardFiltersModal} className={mobileFiltersModalStyle}>
                    <MobileSearchFilters
                        searchFiltersSlots={searchFiltersConfig.slots}
                        searchFiltersCountBySlots={countBySlots}
                        legacyFormProps={legacyFormProps}
                        onMobileCloseModal={closeMobileFilterModal}
                        onMobileResetForm={resetFilters}
                        isAbroad={isAbroad}
                        filtersConfig={{
                            budget: {
                                maxPrice
                            }
                        }}
                    />
                </MobileOptionsModal>
            )}
        </>
    );
}

export const SearchFilters = form<ISearchFiltersFormValues, IProps>(SearchFiltersC);
// interface IOwnProps<TSearchFiltersForm extends {}> {
//     searchFiltersConfig: ISearchFilters<TSearchFiltersForm>;
//     searchFiltersCountBySlots?: Record<string, number>;
//     onClose?: () => void;
//     onResetForm?: () => void;
//     footerClearButtonText?: string;
//     footerSubmitButtonText?: string;
//     isNotificationsSubscriptionModal?: boolean;
//     currency?: Currency;
// }

// interface IProps extends IOwnProps<ISearchFiltersFormValues>, IFormProps<ISearchFiltersFormValues> {}

// export const SearchFiltersWithAccordion = form<ISearchFiltersFormValues, IProps>(SearchFiltersWithAccordionC);

const drawerContentStyle = css({
    display: "flex",
    flexDirection: "column",
    padding: 0,
    overflow: "hidden",
    height: "100%"
});

const mobileFiltersModalStyle = css({
    display: "flex",
    flexDirection: "column"
});
